import axios from 'axios';
import i18n from '../../i18n/i18n';
import { setupGlobalAxiosInterceptor } from './offlineRequestManager';

// Create a singleton instance with a 5-second timeout for better offline snappiness
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 5000,
});

// Add interceptor to include Accept-Language header
axiosInstance.interceptors.request.use(
  (config) => {
    const language = i18n.language || 'ar';
    config.headers['Accept-Language'] = language;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Apply our magical offline logic to this instance
setupGlobalAxiosInterceptor(axiosInstance);

export default axiosInstance;
